import { useCallback, useEffect, useRef, useState } from 'react';

export function useInterval(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback.current == null) return;
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function useCountdown(
  seconds: number,
  initSeconds?: number
): [number, () => void] {
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    if (initSeconds) {
      setTimeLeft(initSeconds);
    }
  }, [initSeconds]);

  const resetCountdown = useCallback(() => {
    setTimeLeft(seconds);
  }, [seconds]);

  useInterval(() => {
    if (!timeLeft) return;

    setTimeLeft(timeLeft - 1);
  }, 1000);

  return [timeLeft, resetCountdown];
}
